import React from 'react';
import HeroSection from '../components/common/HeroSection';
import AboutContent from '../components/about/AboutContent';

const breadcrumb = [
  { key: 'nav.home',  path: '/' },
  { key: 'nav.about', path: null },
];

const AboutUs = () => (
  <>
    <HeroSection
      titleKey="about.title"
      subtitleKey="about.subtitle"
      breadcrumbItems={breadcrumb}
    />
    <AboutContent />
  </>
);

export default AboutUs;
